import { SEND_SMS_REQUEST, SEND_SMS_SUCCESS, SEND_SMS_FAILURE } from '../actions/types';

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const smsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_SMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case SEND_SMS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case SEND_SMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default smsReducer;